import MuiSearchIcon from '@mui/icons-material/Search';

export const SearchIcon = MuiSearchIcon;
